import React from 'react'

function SalaryCalculatorDetailHook() {
  return (
    <div>
     Salary Calculator hook
    </div>
  )
}

export default SalaryCalculatorDetailHook